const TOKEN_KEY = 'jwt_token';
const USER_KEY = 'user_data';

/**
 * Base URL for all API requests.
 * In production (with nginx proxy), this is empty so requests go to /api/...
 * In local development, set REACT_APP_BACKEND_URL=http://localhost:5000 in .env
 */
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const setUser = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

/**
 * Returns headers object with Authorization bearer token.
 * Merges with any additional headers provided.
 */
export const getAuthHeaders = (extraHeaders = {}) => {
  const token = getToken();
  return {
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...extraHeaders,
  };
};

/**
 * Appends the JWT token as a query parameter to a URL.
 * Used for EventSource connections which don't support custom headers.
 * Also prepends API_BASE_URL for local development support.
 */
export const appendTokenToUrl = (url) => {
  const fullUrl = `${API_BASE_URL}${url}`;
  const token = getToken();
  if (!token) return fullUrl;
  const separator = fullUrl.includes('?') ? '&' : '?';
  return `${fullUrl}${separator}token=${encodeURIComponent(token)}`;
};
